import React, { useState, useEffect } from "react";

import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import {
  Breadcrumbs,
  Link,
  withWidth,
  Grid
} from "@material-ui/core";
import DetailSelect from "views/Widgets/FichaPaciente/detailSelect";
import {ButtonTextMUI} from "utils/componentsStyle";
import TableComponent from "views/Widgets/Common/TableComponent";
import { red, green, indigo, orange } from "@material-ui/core/colors";
import ModalDialog from "views/Widgets/Common/ModalDialog";
import moment from "moment-timezone";
import api from "utils/API";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import MomentUtils from "@date-io/moment";

import "moment/locale/es";
import { set } from "date-fns";

moment.locale("es");


const ReportPatient = ({}) => {
  const [selectPatient, setselectPatient] = useState(null);
  const [selectReport, setselectReport] = useState(null);
  const [selectTens, setselectTens] = useState(null);
  const [selectAssingTens, setselectAssingTens] = useState(null);
  const [listPatient, setlistPatient] = useState([]);
  const [listAssingTens, setlistAssingTens] = useState([]);

  const [listTens, setlistTens] = useState([]);

  const [startDate, setstartDate] = useState(null);
  const [endDate, setendDate] = useState(null);
  const [selectTipoSolicitud, setselectTipoSolicitud] = useState([]);

  const listTipoSolicitud = [
    {value: "insumos_medicamentos", label: "Insumos y Medicamentos"},
    {value: "examen", label: "Examen"},
    {value: "traslado", label: "Traslado"},
    {value: "equipo", label: "Equipo"},
  ]

  const listReport = [
    {name: "Reporte Tens", value: "report_tens"},
    {name: "Solicitudes Paciente", value: "report_solicitudes_paciente"},
  ]


  useEffect(() => {
    initialData();
  }, []);

  const initialData = () => {
    let url = "api/paciente/";
    api.get(url).then((response) => {
        setlistPatient(response.data.map((row) => {
            return {
                value: row.id,
                label: `(${row.rut}) ${row.nombre} ${row.apellido_paterno} ${row.apellido_materno}`,
            };
            })
        );
    })
  }

  const handleSelectReport = (row) => {
    setselectReport(row);
    if (row.value === "report_tens") {
      api.get(`api/clinica/tens/paciente/?paciente=${selectPatient.value}&estado=todos`).then((response) => {
        setlistTens(response.data.map((row) => {
              const fileTens = row.ficha_personal
              return {
                  value: row.id,
                  label: `(${fileTens.rut}) ${fileTens.nombres} ${fileTens.apellido_paterno} ${fileTens.apellido_materno}`,
              };
              })
          );
        })
    }
  }

  const handleCloseTensReport = () => {
    setselectReport(null);
    setselectTens(null);
    setselectAssingTens(null);
  }

  const handleGenerateTensReport = () => {
    api.get(`api/clinica/pacientes/reporte/turnos/tens/?turno=${selectAssingTens.value}`,  {  Accept: "application/pdf", responseType: "blob" }).then((response) => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "check_turnos.pdf";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

      //  handleCloseTensReport()
    })
  }

  const handleSelectTensReport = (value) => {
    setselectTens(value);
    api.get(`api/clinica/pacientes/turnos/tens/queryset/?usuario=${value.value}&paciente=${selectPatient.value}`).then((response) => {
      setlistAssingTens(response.data.map((row) => {
            return {
                value: row.id,
                label: `Tipo: ${row.tipo_turno} - (${moment(row.fecha_hora_inicio).format("YYYY-MM-DD HH:mm")})`,
            };
            })
        );
      })
  }

  const handleCloseSolicitudesReport = () => {
    setselectReport(null);
    setstartDate(null);
    setendDate(null);
    setselectTipoSolicitud([]);
  }

  const handleGenerateSolicitudesReport = () => {
    const fechaInicio = moment(startDate).format("YYYY-MM-DD");
    const fechaTermino = moment(endDate).format("YYYY-MM-DD");
    let url = `api/paciente/solicitudes/reporte/?paciente=${selectPatient.value}&fecha_inicio=${fechaInicio}&fecha_termino=${fechaTermino}`;
    if (selectTipoSolicitud.length > 0) {
      url += `&tipo_solicitud=${selectTipoSolicitud.map((row) => row.value).join(",")}`;
    }
    api.get(url, { responseType: "blob" }).then((response) => {
      const blob = new Blob([response.data], { type: response.headers["content-type"] });
      const fileUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = fileUrl;
      a.download = `reporte_solicitudes_paciente_${selectPatient.value}_${fechaInicio}_${fechaTermino}.xlsx`;
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }).catch(async (error) => {
      if (error?.response?.data instanceof Blob) {
        try {
          const text = await error.response.data.text();
          const json = JSON.parse(text);
          if (json.error) {
            alert(json.error);
          }
        } catch (parseError) {
          // cuerpo de error no interpretable como JSON, se deja el manejo global de errores
        }
      }
    })
  }


  const header = [
      {label: "Reporte"},
      {eval: false, label: "Acción"},
  ]


  const data = selectPatient ? listReport.map((row) => {

    const _detailButton_ =  <ButtonTextMUI
      style={{ background: indigo[500] }}
      className="text-white"
      onClick={() => handleSelectReport(row)}
    >
      Detalle
    </ButtonTextMUI>

    return [
      {value: row.name},
      {_value_: _detailButton_}
    ]
  }) :  [[{value: "Seleccione un paciente..."}, {value: " "}]]

  const selectTensReport = selectReport && selectReport.value === "report_tens"
  const generateTensReport = selectTens && selectAssingTens

  const selectSolicitudesReport = selectReport && selectReport.value === "report_solicitudes_paciente"
  const fechasCompletas = startDate && endDate

  const _contentTensReport_ = <div>
     <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      xs={12}
    >
        {listTens.length > 0 &&
          <DetailSelect
              label={`TENS`}
              value={selectTens}
              onchange={(value) => { handleSelectTensReport(value)}}
              list={listTens}
              validation={false}
          />
        }
    </Grid>
     <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      xs={12}
    >
        {listAssingTens.length > 0 &&
          <DetailSelect
              label={`Turno`}
              value={selectAssingTens}
              onchange={(value) => { setselectAssingTens(value)}}
              list={listAssingTens}
              validation={false}
          />
        }
    </Grid>
  </div>

  const _actionsTensReport_ = <>
          {!generateTensReport ?
          <ButtonTextMUI
              disabled
              mr={2}
              variant="contained"
              className="text-white"
          >
              Generar
          </ButtonTextMUI> :
          <ButtonTextMUI
              mr={2}
              variant="contained"
              className="text-white"
              style={{backgroundColor: green[500], marginRight: "3px"}}
              onClick={handleGenerateTensReport}
          >
              Generar
          </ButtonTextMUI>
          }
          <ButtonTextMUI
              mr={2}
              variant="contained"
              style={{backgroundColor: red[500], marginRight: "10px", marginLeft: "3px"}}
              className="text-white"
              onClick={handleCloseTensReport}
          >
              Cerrar
          </ButtonTextMUI>
  </>

  const _contentSolicitudesReport_ = <div>
     <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      xs={12}
    >
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDatePicker
                variant="inline"
                format="DD/MM/YYYY"
                margin="normal"
                label={"Fecha Inicio"}
                placeholder="Fecha Inicio"
                onChange={setstartDate}
                maxDate={endDate ? moment(endDate) : undefined}
                value={startDate}
                inputVariant={"outlined"}
            />
        </MuiPickersUtilsProvider>
        <MuiPickersUtilsProvider libInstance={moment} utils={MomentUtils}>
            <KeyboardDatePicker
                variant="inline"
                format="DD/MM/YYYY"
                margin="normal"
                label={"Fecha Término"}
                placeholder="Fecha Término"
                minDate={startDate ? moment(startDate) : undefined}
                onChange={setendDate}
                value={endDate}
                inputVariant={"outlined"}
            />
        </MuiPickersUtilsProvider>
    </Grid>
     <Grid
      container
      direction="row"
      justify="center"
      alignItems="center"
      xs={12}
    >
        <DetailSelect
            label={`Tipo de Solicitud`}
            value={selectTipoSolicitud}
            onchange={(value) => { setselectTipoSolicitud(value || [])}}
            list={listTipoSolicitud}
            isMulti={true}
            validation={false}
        />
    </Grid>
  </div>

  const _actionsSolicitudesReport_ = <>
          {!fechasCompletas ?
          <ButtonTextMUI
              disabled
              mr={2}
              variant="contained"
              className="text-white"
          >
              Generar
          </ButtonTextMUI> :
          <ButtonTextMUI
              mr={2}
              variant="contained"
              className="text-white"
              style={{backgroundColor: green[500], marginRight: "3px"}}
              onClick={handleGenerateSolicitudesReport}
          >
              Generar
          </ButtonTextMUI>
          }
          <ButtonTextMUI
              mr={2}
              variant="contained"
              style={{backgroundColor: red[500], marginRight: "10px", marginLeft: "3px"}}
              className="text-white"
              onClick={handleCloseSolicitudesReport}
          >
              Cerrar
          </ButtonTextMUI>
  </>
  return (
    <div>
        <GridContainer>
            <GridItem xs={12}>
              <GridItem xs={12}>
                <CardBody className="rounded shadow border border-primary">
                  <Breadcrumbs aria-label="breadcrumb">
                    <Link
                      color="inherit"
                      style={{ cursor: "pointer" }}
                      onClick = {() => setselectReport(null)}
                    >
                      Reportes Pacientes
                    </Link>
                    {selectReport &&
                    <Link
                      color="inherit"
                      style={{ cursor: "pointer" }}
                    >
                      {selectReport.name}
                    </Link>
                    }
                  </Breadcrumbs>
                </CardBody>
              </GridItem>
              <Card>
                <CardBody>
                  <Card style={{ margin: "0x 0", padding: "15px 0" }}>
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="center"
                      xs={12}
                    >
                       {listPatient.length > 0 &&
                          <DetailSelect
                              label={`Paciente`}
                              value={selectPatient}
                              onchange={(value) => { setselectPatient(value)}}
                              list={listPatient}
                              validation={false}
                          />
                        }
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="center"
                      alignItems="center"
                      xs={12}
                    >
                      <TableComponent
                        headers={header}
                        data={data}
                      />
                    </Grid>
                  </Card>
                </CardBody>
              </Card>
            </GridItem>
        </GridContainer>
        {selectTensReport &&
        <ModalDialog
            open={selectTensReport}
            onClose={handleCloseTensReport}
            title={`Reporte Tens - ${selectPatient.label}`}
            _content_={_contentTensReport_}
            _actions_ = {_actionsTensReport_}
            maxWidth="md"
        />
        }
        {selectSolicitudesReport &&
        <ModalDialog
            open={selectSolicitudesReport}
            onClose={handleCloseSolicitudesReport}
            title={`Solicitudes Paciente - ${selectPatient.label}`}
            _content_={_contentSolicitudesReport_}
            _actions_ = {_actionsSolicitudesReport_}
            maxWidth="md"
        />
        }

    </div>
  );
};

export default withWidth()(ReportPatient);
